"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSpecifierDefault;

var _generated = require("./generated");

function isSpecifierDefault(specifier) {
  return (0, _generated.isImportDefaultSpecifier)(specifier) || (0, _generated.isIdentifier)(specifier.imported || specifier.exported, {
    name: "default"
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/types/lib/validators/isSpecifierDefault.js
// module id = F3gT
// module chunks = 0